import styled from 'styled-components/macro';
import Select from 'react-select';

export const Container = styled.div`
  width: 100%;
  max-width: 200px;
  padding: 0 15px 0 5px;
  border-right: ${({ theme, noBorder }) =>
    noBorder ? `none` : `solid 1px ${theme.dark}`};
  margin-right: 15px;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    margin-right: 0;
    border-right: 0;
    border-left: ${({ theme, noBorder }) =>
      noBorder ? `none` : `solid 1px ${theme.dark}`};
    margin-bottom: 5%;
    max-width: 100%;
  }
`;

export const Label = styled.label`
  font-family: ${({ theme }) => theme.primaryFontBold};
  font-size: ${({ theme }) => theme.h5}px;
  color: ${({ theme }) => theme.white};
  width: 100%;
  transition: opacity 0.3s;
`;

export const InputWrapper = styled.div`
  width: 100%;
  height: 25px;
  border-bottom: none;

  svg {
    color: ${({ theme }) => theme.white};
    z-index: 1;
  }
`;

export const Filter = styled(Select)`
  input {
    font-family: ${({ theme }) => theme.primaryFontMedium};
  }
  .select__control {
    border: 0;
    border-radius: 0;
    box-shadow: none;
    color: ${({ theme }) => theme.black};
    height: 25px;
    width: ${({ width }) => (width ? `${width}px` : '100%')} !important;
    background-color: transparent;

    .select__value-container {
      height: 25px;
      padding: 0;
      font-family: ${({ theme }) => theme.primaryFontMedium};
      font-size: ${({ theme }) => theme.h5}px;

      .select__single-value {
        color: ${({ theme }) => theme.white} !important;
      }

      .select__multi-value {
        background-color: ${({ theme }) => theme.black};
        color: ${({ theme }) => theme.black};

        .select__multi-value__label {
          padding-top: 6px;
          background-color: ${({ theme }) => theme.black};
        }
      }

      .select__placeholder {
        color: ${({ theme }) => theme.white};
        font-size: ${({ theme }) => theme.h5}px !important;
      }
    }

    .select__indicator-separator {
      display: none;
    }

    .select__dropdown-indicator,
    .select__clear-indicator {
      padding: 0;
      color: ${({ theme }) => theme.black};
      margin-bottom: 8px;
    }
  }

  .select__menu {
    border-radius: 0;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    margin-top: 0;
    font-family: ${({ theme }) => theme.primaryFontLight};
    font-size: ${({ theme }) => theme.h5}px;
    background-color: ${({ theme }) => theme.light};
    min-width: ${({ minWidth }) => minWidth}px;
    z-index: 6;
  }
`;
